import React from 'react'
import DefaultEditor from "react-simple-wysiwyg";
const TextEditor = () => {
  return (
    <div>
       <DefaultEditor className="summernote" />
    </div>
  )
}

export default TextEditor
